export default __webpack_public_path__ + "static/media/crispy.e11a20a1.PNG";